const userSelector = (state: any) => state.user;
const conversationSelector = (state: any) => state.conversation;
const orgSelector = (state: any) => state.org;
const uploadSelector = (state: any) => state.upload;

export { userSelector, conversationSelector, orgSelector, uploadSelector };
